import * as React from "react"
import { useSetRecoilState, useRecoilValue } from "recoil"
import { Flex } from "@chakra-ui/react"
import { ProductSelectLargeMenu } from "./product-select-large-menu"
import { ProductSelectSmallMenu } from "./product-select-small-menu"
import { pipParamsSelector } from "../../../../recoil/atoms/pictureInPicture"
import { ProductSelectMenuProps } from "./types"
import ProductDescription from "./product-description"
import { productOverlaySelector } from "../../../../recoil/atoms/product-overlay"
import { viewDependingLayoutAtom } from "../../../../recoil/atoms/view"

const _ProductSelectMenu: React.FC<ProductSelectMenuProps> = ({
  isLargeScreen,
  setSelectedVariant,
  selectedVariant,
  selectedQuantity,
  setOptionsSelected,
  setSelectedQuantity,
  optionsSelected,
  largeOptionsContainer,
  isLargeDropDown,
  isSmallScreen,
  isProductWithoutOptions
}) => {
  const {
    options,
    variants,
    coverImages,
    productDescription,
    defaultImageSrc
  } = useRecoilValue(productOverlaySelector)
  const setProductOverlay = useSetRecoilState(productOverlaySelector)
  const { isMobile, isTablet } = useRecoilValue(viewDependingLayoutAtom)
  const setPiPParams = useSetRecoilState(pipParamsSelector)

  let noOfOptions = options?.length

  const handleUnselectProductOption = (selectedOption: {
    name: string
    value: string
    option_id: number
  }) => {
    const selectedProperty = {
      ...optionsSelected
    }

    delete selectedProperty[selectedOption.option_id]

    setOptionsSelected(selectedProperty)

    if (Object.keys(selectedProperty).length === noOfOptions) {
      // search the variant
      const newVariant = variants.find(variant => {
        let flag = true
        variant.option_values.forEach(opt => {
          if (opt.value !== selectedProperty[opt.option_id].value) {
            flag = false
          }
        })
        return flag
      })

      setSelectedVariant(newVariant)

      const image = coverImages?.find(image => {
        return image.variant_ids.find(vId => vId === newVariant.id)
      })
      setProductOverlay({
        action: "update",
        selectedImages: image ? [image.src] : []
      })
      setPiPParams({
        coverImage: image ? image.src : defaultImageSrc
      })
    }
  }

  const onChange = (selectedOption: {
    name: string
    value: string
    option_id: number
  }) => {
    const selectedProperty = {
      ...optionsSelected,
      [selectedOption.option_id]: selectedOption
    }

    setOptionsSelected(selectedProperty)

    if (Object.keys(selectedProperty).length === noOfOptions) {
      // search the variant
      const newVariant = variants.find(variant => {
        let flag = true
        variant.option_values.forEach(opt => {
          if (opt.value !== selectedProperty[opt.option_id].value) {
            flag = false
          }
        })
        return flag
      })

      setSelectedVariant(newVariant)

      const image = coverImages?.find(image => {
        return image.variant_ids.find(vId => vId === newVariant?.id)
      })

      setProductOverlay({
        action: "update",
        selectedImages: image ? [image.src] : []
      })
      setPiPParams({
        coverImage: image ? image.src : defaultImageSrc
      })
    }
  }

  return (
    <Flex
      flexDirection={"column"}
      marginLeft={
        isSmallScreen ? (isProductWithoutOptions ? "0.3rem" : "0rem") : "0.3rem"
      }
      width={
        !isLargeScreen
          ? `calc(100% -  ${
              isSmallScreen ? "0.5rem" : isTablet ? "0.5rem" : "0.3rem"
            })`
          : "100%"
      }
    >
      {isLargeScreen && !isLargeDropDown ? (
        <ProductSelectLargeMenu
          isLargeMenu={isLargeScreen}
          selectedQuantity={selectedQuantity}
          setSelectedQuantity={setSelectedQuantity}
          onChange={onChange}
          largeOptionsContainer={largeOptionsContainer}
          isProductWithoutOptions={isProductWithoutOptions}
          optionsSelected={optionsSelected}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          setOptionsSelected={setOptionsSelected}
          handleUnselectProductOption={handleUnselectProductOption}
        />
      ) : (
        <ProductSelectSmallMenu
          isLargeDropDown={isLargeDropDown}
          handleUnselectProductOption={handleUnselectProductOption}
          selectedQuantity={selectedQuantity}
          setSelectedQuantity={setSelectedQuantity}
          onChange={onChange}
          isProductWithoutOptions={isProductWithoutOptions}
          optionsSelected={optionsSelected}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          setOptionsSelected={setOptionsSelected}
          isSmallScreen={isSmallScreen}
          isLargeMenu={isLargeScreen}
        />
      )}

      <ProductDescription
        description={productDescription}
        isMobile={isMobile}
      />
    </Flex>
  )
}

export const ProductSelectMenu = React.memo(_ProductSelectMenu)
